module.exports = __webpack_public_path__ + "img/manga.fc532cf3.jpg";